module.exports = __webpack_public_path__ + "img/fr_fr.a5ee26c9.svg";